

import _ from "lodash";
import { Component, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { AsnLevel } from "@/models/api/asn/asn";
import { IngestAsnResponse } from "@/models/api/asn/ingest";
import Select from "@/components/form/Select.vue";
import { AsnMap } from "@/models/api/asn/map";

import { AsnFormula } from "@/models/api/asn/formula";
import { RefNum } from "@/models/api/asn/refnum";
import { Lookup } from "@/models/api/asn/lookup";
import { MappableField } from "@/models/api/asn/mappable";
import { ProcessAsnResponse } from "@/models/api/asn/process";


import UploadAsnModal from './UploadAsnModal.vue';
import AsnFormulaModal from './AsnFormulaModal.vue';
import EditMapModal from './EditMapModal.vue';
import CreateMapModal from './CreateMapModal.vue';
import DeleteMapModal from './DeleteMapModal.vue';
import ReferenceNumberModal from './ReferenceNumberModal.vue';
import ImportHistoryModal from './ImportHistoryModal.vue';
import LookupModal from './LookupModal.vue';
import ConfirmProcessModal from './ConfirmProcessModal.vue';
import ImportCompletedModal from './ImportCompletedModal.vue';
import DataInterchangeModal from "./DataInterchangeModal.vue";

import AsnModule from "@/store/modules/asn";
import { SystemModule } from "@/store/modules";

const asnModule = getModule(AsnModule);
const systemModule = getModule(SystemModule);

interface DeliveryForOption {
  label: string;
  value: number;
}


@Component({
  components: {
    Select,
    UploadAsnModal,
    AsnFormulaModal,
    CreateMapModal,
    EditMapModal,
    DeleteMapModal,
    ReferenceNumberModal,
    LookupModal,
    ImportHistoryModal,
    ConfirmProcessModal,
    ImportCompletedModal,
    DataInterchangeModal
  }
})
export default class UploadAsn extends Vue {
    UploadId: string = null;
    IngestedASN: IngestAsnResponse = null;

    SelectedMap: AsnMap = null;
    AsnLevel: AsnLevel;

    DeliveryFor: number = null;
    DeliveryFors: DeliveryForOption[] = [];

    MappableAll: MappableField[] = [];
    Mappable: MappableField[] = [];
    ColumnMap: string[] = [];
    Formulas: AsnFormula[] = [];
    ReferenceNumbers: RefNum[] = [];
    Lookups: Lookup[] = [];
    Imported: ProcessAsnResponse = null;

    ImportHeaderId: number | null = null;

    IsAgent: boolean = false;

    ShowUploadModal: boolean = true;
    ShowFormulaModal: boolean = false;
    ShowCreateMapModal: boolean = false;
    ShowEditMapModal: boolean = false;
    ShowDeleteMapModal: boolean = false;
    ShowReferenceNumberModal: boolean = false;
    ShowLookupModal: boolean = false;
    ShowConfirmProcessModal: boolean = false;
    ShowImportHistoryModal: boolean = false;
    ShowImportCompletedModal: boolean = false;
    ShowDataInterchangeModal: boolean = false;

    CanComplete: boolean = false;

    IsLoadingImportCompeted: boolean = false;

    async getIngestedAsn(uploadId: string){
      let response = await asnModule.getIngestedAsn(uploadId);

      if (response !== null && response !== undefined){
        this.IngestedASN = response;
        
        for(let i = 0; i < this.IngestedASN.columns; i++){
          this.ColumnMap.push('');
        }

        await this.getMappableFields();
      }
    }

    async getMappableFields(){
      let mappable = await asnModule.getMappableFields(this.IngestedASN.asnLevel);

      if (mappable !== null && mappable !== undefined) {
        for(let i = 0; i < mappable.fields.length; i++){
          this.Mappable.push(mappable.fields[i]);
          this.MappableAll = this.Mappable;
        }
      }
    }

    async onMapSelected(map: AsnMap){
      if (map.id == null){
        let saved = await asnModule.createMap({ displayName: map.displayName, asnLevel: map.asnLevel });
        this.SelectedMap = saved;
        this.ShowEditMapModal = true;
      }
      else {
        this.SelectedMap = map;
      }

      if (this.SelectedMap !== null){
        await systemModule.loadDeliveryFors();
        this.DeliveryFors = systemModule.deliveryFors.map(x => ({ label: x.name, value: x.id }));
        if (this.DeliveryFors !== null && this.DeliveryFors.length > 0){
          this.DeliveryFor = this.DeliveryFors[0].value;
        }
      }

      if (this.SelectedMap.json !== null){
        let parsed = JSON.parse(this.SelectedMap.json);
        this.ColumnMap = parsed.ColumnMap;
        this.Formulas = parsed.Formulas;
        this.ReferenceNumbers = parsed.ReferenceNumbers;
        this.Lookups = parsed.Lookups;

        

        if (typeof(this.ColumnMap) == 'undefined'){
          this.ColumnMap = [];
          for(let i = 0; i < this.IngestedASN.columns; i++){
            this.ColumnMap.push('');
          }
        }

        if (typeof(this.Formulas) == 'undefined'){
          this.Formulas = [];
        }

        if (typeof(this.ReferenceNumbers) == 'undefined'){
          this.ReferenceNumbers = [];
        }

        if (typeof(this.Lookups) == 'undefined'){
          this.Lookups = [];
        }
      }
    }

    async onFileUploaded(id: string){
      await this.getIngestedAsn(id);
      this.UploadId = id;
      this.ShowUploadModal = false;
    }

    async onConfirmDelete(){
      await asnModule.deleteMap(this.SelectedMap.id);
      this.SelectedMap = null;
      this.ShowDeleteMapModal = false;
      this.ShowUploadModal = true;
    }

    async saveChanges(){
      await asnModule.updateMap({
        id: this.SelectedMap.id,
        asnLevel: this.SelectedMap.asnLevel,
        displayName: this.SelectedMap.displayName,
        json: JSON.stringify({
          "ColumnMap": this.ColumnMap,
          "Formulas": this.Formulas,
          "ReferenceNumbers": this.ReferenceNumbers,
          "Lookups": this.Lookups
        })
      });
    }

    async onToggleFormulaModal(){
      this.ShowFormulaModal = !this.ShowFormulaModal;
    }

    async onToggleLookupModal(){
      this.ShowLookupModal = !this.ShowLookupModal;
    }

    async onToggleReferenceNumberModal(){
      this.ShowReferenceNumberModal = !this.ShowReferenceNumberModal;
    }

    async onToggleCreateMapModal(){
      this.ShowCreateMapModal = !this.ShowCreateMapModal;
    }

    async onToggleUploadModal(){
      this.ShowUploadModal = !this.ShowUploadModal;
    }

    async onToggleEditMapModal(){
      this.ShowEditMapModal = !this.ShowEditMapModal;
    }

    async onToggleDeleteMapModal(){
      this.ShowDeleteMapModal = !this.ShowDeleteMapModal;
    }

    async onToggleHistoryModal(){
      this.ShowImportHistoryModal = !this.ShowImportHistoryModal;
    }

    async onToggleConfirmProcessModal(){
      this.ShowConfirmProcessModal = !this.ShowConfirmProcessModal;
    }

    async onShowImportHeader(importHeaderId){
      this.ImportHeaderId = importHeaderId;
      this.ShowDataInterchangeModal = true;
    }

    async onEditSave(map){
      this.SelectedMap = map;
      this.ShowEditMapModal = false;
    }

    async onFormulaModalOk(){
      await this.saveChanges();
    }

    async onLookupModalOk(){
      await this.saveChanges();
    }

    async onDataInterchangeModalOk(){
      this.ShowDataInterchangeModal = false;
    }

    async onReferenceNumberModalOk(){
      await this.saveChanges();
    }

    async onFormulaAdded(){
      this.Formulas.push({ id: window.crypto['randomUUID'](), map: "", valueType: "Text", value: { label: "", value: ""}, textValue: "" });
    }

    async onLookupAdded(){
      this.Lookups.push({ id: window.crypto['randomUUID'](), kvp: [{ key:'', value:'' }], map: "" });
    }

    async onRefNumAdded(){
      this.ReferenceNumbers.push({ id: window.crypto['randomUUID'](), map: "", referenceType: { label: "", value: "" }, valueType: "Text", value: "", textValue: "" });
    }

    async onFormulaRemoved(formula: AsnFormula){
      this.Formulas = this.Formulas.filter(x => x.id !== formula.id);
    }

    async onLookupRemoved(lookup: Lookup){
      this.Lookups = this.Lookups.filter(x => x.id != lookup.id);
    }

    async onRefNumRemoved(refnum: RefNum){
      this.ReferenceNumbers = this.ReferenceNumbers.filter(x => x.id !== refnum.id);
    }

    async onFormulaUpdated(formula: AsnFormula){
      this.Formulas = this.Formulas.filter(x => x.id !== formula.id); 
      this.Formulas.push(formula);
    }

    async onRefNumUpdated(refnum: RefNum){
      this.ReferenceNumbers = this.ReferenceNumbers.filter(x => x.id !== refnum.id);
      this.ReferenceNumbers.push(refnum);
    }

    async onLookupUpdated(lookup: Lookup){
      this.Lookups = this.Lookups.filter(x => x.id !== lookup.id);
      this.Lookups.push(lookup);
    }

    async onPreviewValidated(preview){
      this.CanComplete = !preview.error;
    }

    async onConfirmProcessModalOk(){
      this.ShowConfirmProcessModal = false;
      await this.onProcessASNConfirmed(); 
    }

    async onImportCompletedModalOk() {
      this.ShowImportCompletedModal = false;

      if (this.Imported.success){
        this.ShowUploadModal = true;
      }
    }

    async onConfirmProcessModalCancel(){
      this.ShowConfirmProcessModal = false;
    }

    async onImportHistoryOk(){
      this.ShowImportHistoryModal = false;
    }

    async onProcessASN(){
      this.ShowConfirmProcessModal = true;
    }

    async onProcessASNConfirmed(){
      this.ShowConfirmProcessModal= false;
      this.IsLoadingImportCompeted = true;
      this.Imported = await asnModule.processAsn({ uploadId: this.UploadId, mapId: this.SelectedMap.id, deliveryFor: this.DeliveryFor });
      this.IsLoadingImportCompeted = false;
      this.ShowImportCompletedModal = true;
    }

    @Watch("ColumnMap")
    async selectedColumnMapChanged(newValue){
      this.Mappable = this.MappableAll;
      for(let i = 0; i < newValue.length; i++){
        this.Mappable = this.Mappable.filter(x => x !== newValue[i]);
      } 

      await this.saveChanges();
    }

    async created(){
      this.IsAgent = (this.$route.hash === '#agent');

      if (this.IsAgent){
          await systemModule.loadDeliveryFors();
          this.DeliveryFors = systemModule.deliveryFors.map(x => ({ label: x.name, value: x.id }));
          if (this.DeliveryFors !== null && this.DeliveryFors.length > 0){
            this.DeliveryFor = this.DeliveryFors[0].value;
          }
      }
    }
}

